import {levels} from './constants';

const types = {...levels};
export default types;
